import { marked } from 'marked';

import { MeetingAnalysisDto } from '@/api/generated';

const HubspotEngagementDescription = (
  meetingTitle: string | undefined,
  meetingAnalysis: MeetingAnalysisDto | undefined,
  participants: string[] | undefined
) => {
  const participantsString = participants?.join(', ') || '';
  const sectionsString =
    meetingAnalysis?.sections
      ?.map(section => {
        const markedString = marked(section.content || '');
        return `<h6>${section.title}</h6>${markedString}</br>`;
      })
      .join('') || '';
  const htmlString = `<h1>${meetingTitle}</h1></br><h6>Participants:</h6><p>${participantsString}</p></br>${sectionsString}`;
  return htmlString;
};

export default HubspotEngagementDescription;
